import {takeLatest, takeLeading, put, select} from "redux-saga/effects";

import {LOGOUT_INITIATED} from "@atg-global-shared/user/userActionTypes";
import {AuthSelectors} from "@atg-shared/auth";
import {ApolloClientInstance} from "@atg-tillsammans/apollo-data-access";
import {
    TeamMemberActions,
    TeamMemberSelectors,
} from "@atg-tillsammans/team-member-data-access";

import {AppActions, type EnterAppContextAction} from "./appActions";
import {APP_CONTEXT_ENTER} from "./appConstants";

import type {SagaIterator} from "redux-saga";

export async function clearApolloCache() {
    await ApolloClientInstance.clearCache();
}

export function* initTillsammans({
    payload: {options},
}: EnterAppContextAction): SagaIterator {
    const isLoggedIn = yield select(AuthSelectors.isLoggedIn);

    if (!isLoggedIn) return;

    yield put(AppActions.userEnteredTillsammans(options));

    const cachedAt = yield select(TeamMemberSelectors.selectTeamsCachedAt);

    if (!cachedAt) yield put(TeamMemberActions.fetchMemberTeams({}));
}

export function* appSaga(): SagaIterator {
    yield takeLeading(APP_CONTEXT_ENTER, initTillsammans);
    yield takeLatest(LOGOUT_INITIATED, clearApolloCache);
}
